<div class="pageheader">
  <div class="page-title">
    <h1>Control Test</h1>
  </div>
</div>

<a routerLink="decorator" routerLinkActive ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" #decoratorLink="routerLinkActive" class="btn"
  [class.btn-success]="decoratorLink.isActive" [class.btn-primary]="!decoratorLink.isActive">Controls and decorators</a>
&nbsp;
<a routerLink="reactive" routerLinkActive ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" #reactiveLink="routerLinkActive" class="btn"
  [class.btn-success]="reactiveLink.isActive" [class.btn-primary]="!reactiveLink.isActive">Reactive forms</a>
&nbsp;
<a routerLink="template" routerLinkActive ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" #templateLink="routerLinkActive" class="btn"
  [class.btn-success]="templateLink.isActive" [class.btn-primary]="!templateLink.isActive">Template forms</a>
&nbsp;
<a routerLink="two-way" routerLinkActive ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" #twoWayLink="routerLinkActive" class="btn" [class.btn-success]="twoWayLink.isActive"
  [class.btn-primary]="!twoWayLink.isActive">Two way binding</a>

<div class="mt-3">
  <router-outlet></router-outlet>
</div>
